import React from 'react';
import LegalPage from '@/components/LegalPage';
import { Seo, breadcrumbSchema, webPageSchema } from '../components/Seo';

const Terms = () => (
  <>
    <Seo
      title="Terms & Conditions · AdAura Awards 2026"
      description="Terms and conditions of use for the AdAura Awards 2026 website, nominator portal and jury chamber. Presented by Marketing Mind."
      path="/terms"
      jsonLd={[
        webPageSchema({ path: '/terms', name: 'Terms', description: 'Terms and conditions of use for the AdAura Awards 2026.' }),
        breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Terms', path: '/terms' }]),
      ]}
    />
  <LegalPage
    kicker="Legal"
    title="Terms & Conditions"
    lastUpdated="26 February 2026"
  >
    <p>
      These Terms govern your participation in <strong>The AdAura Awards 2026</strong>{' '}
      (“the Awards”), presented by Marketing Mind from Noida, India. By
      registering a nomination, accepting a jury invitation, or paying an entry
      fee, you accept and agree to these Terms in full.
    </p>

    <h2>1. The programme</h2>
    <p>
      The AdAura Awards 2026 recognises excellence in advertising, brand
      storytelling and integrated marketing communication across 10 pillars and
      50+ categories. Marketing Mind reserves the sole editorial right to add,
      remove or merge categories, alter pillar structures, change deadlines or
      Awards Night logistics — with reasonable notice given to nominators.
    </p>

    <h2>2. Eligibility</h2>
    <ul>
      <li>Work submitted must have run for a market in India between <strong>1 July 2025 and Till Date</strong>.</li>
      <li>Entries may be submitted by brands, agencies, production houses, in-house teams, freelancers, or any party with demonstrable involvement.</li>
      <li>Multiple parties may nominate the same campaign. A single jury winner per category is selected on merit; co-credit is awarded to all named contributors.</li>
      <li>Work that breaches Indian advertising standards, ASCI guidelines, or applicable laws will be disqualified without refund.</li>
    </ul>

    <h2>3. Submission</h2>
    <ul>
      <li>All entries must be submitted through the official portal at <strong>adauraawards.com/enter</strong>. Emailed or hand-delivered entries are not accepted.</li>
      <li>The nominator warrants that they have authority to submit the work and that all credits, claims, results and attached assets are accurate.</li>
      <li>Marketing Mind reserves the right to verify any claim and to remove any entry whose details are found to be misleading.</li>
      <li>The entry deadline for the 2026 edition is <strong>6 September 2026, 23:59 IST</strong>. Late entries are not accepted.</li>
    </ul>

    <h2>4. Fees, GST &amp; payment</h2>
    <ul>
      <li>The entry fee per nomination is displayed on the Categories page and at the time of payment. All fees are exclusive of GST; <strong>18% IGST/CGST+SGST</strong> is added at checkout as applicable.</li>
      <li>Payment is processed by Razorpay. Marketing Mind does not store card or banking credentials.</li>
      <li>A GST-compliant tax invoice is auto-emailed within minutes of payment confirmation. For invoice corrections, contact our awards desk within 7 days.</li>
    </ul>

    <h2>5. Intellectual property &amp; usage rights</h2>
    <ul>
      <li>You retain full ownership of the campaign, creative work and any assets you submit.</li>
      <li>By submitting, you grant Marketing Mind a <strong>non-exclusive, royalty-free, worldwide licence</strong> to display the work on the AdAura platform, in award-night reels, in editorial coverage, on social media, and in the AdAura case-study library — in perpetuity and crediting all named contributors.</li>
      <li>If any third-party clearances (talent, music, footage) restrict this use, the nominator must declare it at submission. We will then restrict the use accordingly.</li>
    </ul>

    <h2>6. Jury &amp; judging</h2>
    <ul>
      <li>All entries are judged <strong>blind</strong> — entrant, brand and agency identifiers are removed before the jury sees them.</li>
      <li>Each entry is scored across five axes — Strategy, Creativity, Execution, Impact, Innovation — by jurors qualified for that category.</li>
      <li>The jury’s decision is final and not subject to appeal, correspondence or external arbitration.</li>
      <li>Conflicts of interest are auto-detected and excluded — jurors do not score work from their own current employer or named clients.</li>
    </ul>

    <h2>7. Disqualification</h2>
    <p>
      Marketing Mind reserves the right to disqualify, without refund, any
      entry found to be fraudulent, plagiarised, in breach of Indian law, or in
      breach of these Terms. Awards announced for such entries will be
      retracted publicly.
    </p>

    <h2>8. Cancellation &amp; refunds</h2>
    <p>
      Refer to our separate{' '}
      <a href="/refund" className="text-[#9F6A2C] underline decoration-[#B8884A]/40 underline-offset-4 hover:decoration-[#9F6A2C]">Refund Policy</a>.
    </p>

    <h2>9. Liability</h2>
    <p>
      Marketing Mind’s aggregate liability arising out of or in connection with
      the Awards is limited to the entry fee actually paid by you. We are not
      liable for indirect, consequential or reputational damages.
    </p>

    <h2>10. Governing law</h2>
    <p>
      These Terms are governed by the laws of India. Any dispute is subject to
      the exclusive jurisdiction of the courts in <strong>Gautam Budh Nagar, Uttar Pradesh</strong>.
    </p>

    <h2>11. Changes</h2>
    <p>
      We may revise these Terms before the deadline of each edition. Material
      changes will be announced via email to registered nominators. Continued
      use of the portal after a change constitutes acceptance of the revised
      Terms.
    </p>
  </LegalPage>
  </>
);

export default Terms;
